import { ChatService } from './chat.service';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChatMessage } from '../model/chat.message';
import { VariableService } from './variable.service';
import { ChatCommonService } from './chat-common.service';
import { ChatApiCallService } from './chat-api-call.service';
import { AuthService } from './auth.service';
import { ChatErrorService } from './chat-error.service';
import { ChatUserTyping } from '../model/user-interfaces';

@Injectable({
  providedIn: 'root'
})
export class MessageSocketService {
  subScriptions: Subscription[] = [];
  seen = false;
  isAtBottom = true;
  constructor(
    private chatService: ChatService,
    private vars: VariableService,
    private chatCommonService: ChatCommonService,
    private apiCallService: ChatApiCallService,
    private authService: AuthService,
    private errorService: ChatErrorService
  ) { }


  subscribeToSocketMessages() {
    try {
      this.subScriptions.push(
        this.chatService.getMessages.subscribe((res: ChatMessage) => {
          console.log('getMessages res', res);
          const roomId = res?.roomId;
          res.options = this.chatCommonService.parsify(res.options);
          if (res.senderId) {
            res.authorId = res.senderId;
          }

          let liveRoomIndex = this.vars?.liveRooms.findIndex(user => user?.roomId == roomId);
          if (liveRoomIndex > -1) {
            this.vars.liveRooms[liveRoomIndex].lastMessage = res;
            if (res?.roomId != this.vars?.selectedChat?.roomId) {
              this.vars.liveRooms[liveRoomIndex].unReadCount += 1;
            }
          } else {
            let unassignedIndex = this.vars.unAssignedRooms.findIndex(user => user?.roomId == roomId);
            if (unassignedIndex > -1) {
              this.vars.unAssignedRooms[unassignedIndex].lastMessage = res;
              if (res?.roomId != this.vars?.selectedChat?.roomId) {
                this.vars.unAssignedRooms[unassignedIndex].unReadCount += 1;
              }
            } else {
              let mentionedIndex = this.vars.mentionedRooms.findIndex(user => user?.roomId == roomId);
              if (mentionedIndex > -1) {
                this.vars.mentionedRooms[mentionedIndex].lastMessage = res;
                if (res?.roomId != this.vars?.selectedChat?.roomId) {
                  this.vars.mentionedRooms[mentionedIndex].unReadCount += 1;
                }
              }
            }
          }
          if (res?.room && !res?.room?.isAgentAssign) {
            let index = this.vars?.unAssignedRooms?.findIndex(room => room?.roomId == roomId);
            if (index < 0) {
              this.vars.unAssignedRooms.unshift(res?.room);
            }

            // if(this.vars?.openTab == 'unassigned'){
            //   this.vars?.users.unshift(res?.room);
            // }
          }
          if (roomId == this.vars?.selectedChat?.roomId) {
            this.addOrUpdateMessage(res);
          }
          this.sortUsersByTimestamp();
        }, (err) => {
          console.log('Get Message err', err);
        })
      );

      this.subScriptions.push(
        this.chatService.unassignedRoom.subscribe((res) => {
          let index = this.vars?.unAssignedRooms.findIndex(room => room?.roomId == res?.room.roomId);
          if (index > -1) {
            this.vars.liveRooms.unshift(this.vars?.unAssignedRooms[index]);
            this.vars.unAssignedRooms.splice(index, 1);
          }
          console.log('room assigned res', res);
        }));


      //typing socket 
      this.subScriptions.push(
        this.chatService.getUserTyping.subscribe((res: ChatUserTyping) => {
          if (!res || res.userId === Number(this.uId)) return;
          console.log('typings', res);
          const indexOfOnline = this.vars.users.findIndex((room: any) => room?.roomId === res?.roomId);
          const isStopTyping = res.username?.toLocaleLowerCase()?.includes("stop");
          if (indexOfOnline !== -1) {
            if (isStopTyping) {
              if (this.vars.users[indexOfOnline].typingTimer) {
                clearTimeout(this.vars.users[indexOfOnline].typingTimer);
              }
              this.vars.users[indexOfOnline].typing = false;
            } else {
              this.vars.users[indexOfOnline].typing = true;
              this.vars.users[indexOfOnline].typingUserName = res.username;
              this.vars.users[indexOfOnline].typingUserId = res?.userId;

              if (this.vars.users[indexOfOnline].typingTimer) {
                clearTimeout(this.vars.users[indexOfOnline].typingTimer);
              }

              this.vars.users[indexOfOnline].typingTimer = setTimeout(() => {
                this.vars.users[indexOfOnline].typing = false;
              }, 3000);
            }
          }

          // Update typing state for the current room
          if (res?.roomId === this.vars.roomId) {

            if (isStopTyping) {
              if (this.vars.selectedChat.typingTimer) {
                clearTimeout(this.vars.selectedChat.typingTimer);
              }
              this.vars.selectedChat.typing = false;
            } else {
              this.vars.selectedChat.typing = true;
              this.vars.selectedChat.typingUserName = res.username;
              this.vars.selectedChat.typingUserId = res?.userId;

              if (this.vars.selectedChat.typingTimer) {
                clearTimeout(this.vars.selectedChat.typingTimer);
              }

              this.vars.selectedChat.typingTimer = setTimeout(() => {
                this.vars.selectedChat.typing = false;
              }, 3000);
            }
          }
        })
      );


      this.subScriptions.push(
        this.chatService.closeRoom.subscribe((res: any) => {
          let index = this.vars?.liveRooms.findIndex(room => room?.roomId == res?.roomId);
          if (index > -1) {
            this.vars?.liveRooms[index].status == res?.status;
          }
          if (this.vars?.selectedChat && this.vars?.selectedChat?.roomId == res?.roomId) {
            this.vars.selectedChat.status = res?.status;
          }
          console.log('closeRoom res', res);
        }));

      this.subScriptions.push(
        this.chatService.onlineStatus.subscribe((res) => {
          if (this.authService?.isAdmin) {
            this.apiCallService.getAgentsStats();
          }
          let index = this.vars.agentList.findIndex(user => user?.userId == res?.userId);
          if (index > -1) {
            this.vars.agentList[index].status = res?.status;
          }

          console.log('onlineStatus res', res);
        }));

      this.subScriptions.push(
        this.chatService.mentionAgent.subscribe((res: any) => {
          if(this.vars?.mentionedRooms?.length){
            let index = this.vars?.mentionedRooms?.findIndex(room => room?.roomId == res?.roomId);
            if(index < 0){
              this.vars?.mentionedRooms.unshift(res);
            }
          }else{
            this.vars?.mentionedRooms.unshift(res);
          }
          this.errorService.showSnackbarToast('You have been mentioned in a chat', 'success');
          console.log('mentionAgent res', res);
        }));
    } catch (error) {
      console.log('mentionAgent error', error);
    };
  }

  initEvents() {
    this.subscribeToSocketMessages();
  }

  get uId() {
    return this.chatCommonService.myUid();
  }

  get chatMessages() {
    return this.vars.chatMessages;
  }

  addOrUpdateMessage(res: ChatMessage) {
    const tmid = res?.tmid;
    if (res?.authorId == this.uId && tmid) {
      const chatIndex = this.chatMessages?.findIndex(item => item?.tmid && tmid == item?.tmid);
      if (chatIndex >= 0) {
        this.chatMessages[chatIndex] = { ...this.chatMessages[chatIndex], ...res };

        this.chatMessages[chatIndex].loading = false;
        if (typeof this.chatMessages[chatIndex]?.mentions == 'string') {
          this.chatMessages[chatIndex].mentions = JSON.parse(this.chatMessages[chatIndex]?.mentions);
        }
        this.chatMessages[chatIndex].mentions = this.chatMessages[chatIndex].mentions?.map((mention: any) => typeof mention == 'string' ? JSON.parse(mention) : mention);
        this.chatMessages[chatIndex].tempLoader = false;

        this.chatMessages[chatIndex].status = 'sent';
        // console.log('addOrUpdateMessage message update', this.chatMessages[chatIndex]);
        if (this.chatMessages[chatIndex]?.timeout1Id) {
          clearTimeout(this.chatMessages[chatIndex].timeout1Id);
          // console.warn('timeout1Id cleared',);
        }
        if (this.chatMessages[chatIndex].timeout1Id) {
          clearTimeout(this.chatMessages[chatIndex].timeout2Id);
          // console.warn('timeout12d cleared',);
        }


      }
      else {
        console.log(`Not found any record chatIndex ${chatIndex}`,);
        res.loading = false;
        res.tempLoader = false;
        this.addMessage(res);
      }
    }
    else {
      res.loading = false;
      res.tempLoader = false;
      this.addMessage(res);
    }
  }


  addMessage(newMessage: ChatMessage): void {
    if (newMessage?.attachments?.length) {
      newMessage.attachments[0].authorId = newMessage.authorId;
      newMessage.attachments[0].id = newMessage?.id
      newMessage.attachments[0].messageId = newMessage?.messageId;
      // newMessage.attachments[0].tmid = newMessage?.tmid;
    }
    if (newMessage.senderId) {
      newMessage.authorId = newMessage.senderId;
    }
    newMessage.options = this.chatCommonService.parsify(newMessage.options);
    if (newMessage?.reply) {
      newMessage.reply.options = this.chatCommonService.parsify(newMessage?.reply?.options);
    }
    newMessage.mentions = newMessage.mentions?.map((mention: any) => typeof mention == 'string' ? JSON.parse(mention) : mention);
    if (typeof newMessage?.mentions == 'string') {
      newMessage.mentions = JSON.parse(newMessage?.mentions);
    }
    const chatIndex = this.chatMessages?.findIndex(item => newMessage?.tmid && item?.tmid && newMessage?.tmid == item?.tmid);
    if (chatIndex < 0) {
      this.chatMessages?.unshift(newMessage);
    }

    // if (this.isAtBottom)
    this.scrollAndDetectChanges();
    // if (newMessage?.attachments?.length && newMessage?.attachments[0]?.audio_url) {
    // this.initAudioFile(newMessage);
    // }
    // this.chatCommonService.dataOut.emit({ action: 'cdr' });
  }

  scrollAndDetectChanges(elementId = '') {
    setTimeout(() => {
      this.apiCallService.scrollTo(false, elementId);
    });
  }

  sortUsersByTimestamp() {
    this.vars.users = this.vars.users?.sort((a, b) => {
      const getTimestamp = (user: any) => {
        if (user?.lastMessage?.ts) {
          return new Date(user.lastMessage.ts).getTime();
        }
        if (user?.ts) {
          return new Date(user.ts).getTime();
        }
        return 0;
      };
      return getTimestamp(b) - getTimestamp(a);
    });
  }
}
